import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Button, CircularProgress } from "@mui/material";

interface ResetPasswordSubmitViewProps {
  isLoading: boolean;
}

const ResetPasswordSubmitView: React.FC<ResetPasswordSubmitViewProps> = ({
  isLoading,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <Button
      type="submit"
      variant="contained"
      className="!bg-[#18181b] !text-white"
      fullWidth
      disabled={isLoading}
      sx={{
        py: 1.5,
        fontWeight: 700,
        fontSize: { xs: "1rem", sm: "1.1rem" },
        borderRadius: 2,
        boxShadow: 2,
        textTransform: "none",
      }}
    >
      {isLoading ? (
        <>
          {t("actions.submitting")}
          <CircularProgress size={22} sx={{ color: "white", ml: 2 }} />
        </>
      ) : (
        t("actions.send")
      )}
    </Button>
  );
};

export default ResetPasswordSubmitView;
